// ToneChip — tiny badge showing the AI-scored emotional temperature of an
// inbound message. Renders only when we have a tone; silent otherwise.
//
// Five tones:
//   calm    — default neutral, rendered only on explicit score (not on missing data)
//   happy   — warm, enthusiastic customer
//   anxious — worried / uncertain / urgent concern
//   annoyed — frustrated but not hostile
//   angry   — hostile / escalated / threats
//
// Each tone gets a color and an emoji-less label. Kept to 1 word so the chip
// stays compact. Appears at the top of an inbound bubble, right of the sender
// name.

export type MessageTone = 'calm' | 'happy' | 'anxious' | 'annoyed' | 'angry';

interface ToneChipProps {
  tone: MessageTone | null | undefined;
}

const TONE_LABEL: Record<MessageTone, string> = {
  calm: 'calm',
  happy: 'happy',
  anxious: 'anxious',
  annoyed: 'annoyed',
  angry: 'heated',
};

const TONE_CLASS: Record<MessageTone, string> = {
  calm: 'tone-calm',
  happy: 'tone-happy',
  anxious: 'tone-anxious',
  annoyed: 'tone-annoyed',
  angry: 'tone-angry',
};

export function ToneChip({ tone }: ToneChipProps) {
  if (!tone) return null;
  return (
    <span
      className={`tone-chip ${TONE_CLASS[tone]}`}
      title={`This message reads as ${TONE_LABEL[tone]}`}
    >
      {TONE_LABEL[tone]}
    </span>
  );
}
